<template>
  <div>
      <ul class="collection" v-if="sortedNextSessions.length > 0">
          <li class="collection-item avatar" v-for="(session, index) in sortedNextSessions" :key="session.id">
              <i class="icon-text circle center" :class="session.intensity | intensityColor">{{session.shortCode}}</i>
              <span class="title">{{session.name}}</span>
              <p>{{session.type}} {{session.title}} <br>
                  <small v-if="session.restBefore">Rest one day before</small>
              </p>
              <router-link v-if="index==0" :to="{ name: 'Session', params: { session: session, isPastSession: false, user: user  }}" class="secondary-content btn-floating pulse"><i
                      class="material-icons">play_circle_outline</i>
              </router-link>
              <router-link v-else-if="isCoach()" :to="{ name: 'Session', params: { session: session, isPastSession: false, user: user  }}" class="secondary-content"><i
                      class="material-icons">pageview</i>
              </router-link>

          </li>
      </ul>
      <div v-else>
        <SessionCompleted :name="name" :user="user" :callback="callbackSessionListUpdated"/>
      </div>
  </div>
</template>

<script>
import api from '@/api'
import SessionCompleted from '@/components/cards/SessionCompleted'
export default {
  name: 'nextSessionList',
  props: {
    'user': Object
  },
  components: { SessionCompleted },
  data: function () {
    return {
      nextSessions: [], // list of sessions
      name: undefined
    }
  },
  created () {
    this.name = this.user.athlete.name
    this.nextSessions = api.getNextSessions(this.user)
  },
  computed: {
    // sort the next session by ascending index
    sortedNextSessions () {
      return this.nextSessions.sort((a, b) => a.index - b.index)
    }
  },
  methods: {
    callbackSessionListUpdated (user) {
      this.user = user
      this.nextSessions = api.getNextSessions(this.user) // refresh
    },
    isCoach () {
      return api.hasRole('coach')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/sessions/NextSessionList.vue